var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage } from "@irati/utils/lang";
import id from "@irati/utils/id";
import successImage from "@irati/ui/images/success.svg";
import { Img, Wrapper, Text, Title } from "./styled";
var Success = function (_a) {
    var message = _a.message, withMarginTop = _a.withMarginTop, props = __rest(_a, ["message", "withMarginTop"]);
    var idNamespace = id("success", props);
    return (React.createElement(Wrapper, { id: idNamespace, withMarginTop: withMarginTop },
        React.createElement(Row, null,
            React.createElement(Col, { md: 6, mdOffset: 3 },
                React.createElement(Img, { id: id("img", idNamespace), src: successImage, alt: "Success" }),
                React.createElement(Title, { id: id("title", idNamespace) },
                    React.createElement(FormattedMessage, { id: "platform.successStep.success.title" })),
                message && React.createElement(Text, { id: id("copy-message", idNamespace) }, message)))));
};
export default Success;
